export function dateTimeToDateString(dateTime: Date | undefined | null, defaultText?: string): string {
    if (dateTime === undefined || dateTime === null) {
        return defaultText ?? "";
    }
    let date: string;
    date = dateTime.toString().slice(0, 10);
    return date;
}

export function formatDate(date?: Date, emptyDateString?: string | undefined) {
    if (date === null || date === undefined) {
        return emptyDateString ?? "-";
    }

    var d = date ? new Date(date) : new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export function addToMonth(date: Date | undefined, months: number) {
    var d = new Date(date || new Date());
    d.setMonth(d.getMonth() + (months || 0), d.getDate());
    return d;
}

export const getDateFromDefaultValueToday = () => {
    const today = new Date();
    return today;
}

export const getStartAndEndDateDisplayValue = (dateFrom?: Date, dateTo?: Date) => {
    if (!dateFrom) {
        return '';
    }

    const from = formatDate(dateFrom);
    const to = dateTo ? formatDate(dateTo) : 'Tillsvidare';

    return `${from} - ${to}`;
}

export function formatDateToyyyyMMddHHmm(date: Date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    return `${year}${month}${day}${hours}${minutes}`;
}